(ns teamoesterreich.user-mode.navigation.cookie-warning
  (:require [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent.core :as r]

            [teamoesterreich.store :as store]))




(defn bottom-drawer-content []
  (let [!cookie-ok (r/cursor store/app-state [:actual-user :cookie-ok])]
    [:div
     {:style {:backgroundColor "white" :padding "7px" :overflow-y "auto" :height "160px" :maxWidth "800px" :margin "0 auto 0 auto" :color "#ea1c22" :textAlign "left"}}
     [:p "Unsere Webseite verwendet Cookies bzw IndexedDB."
      [:br]
      "Bei Cookies und IndexedDB handelt es sich um Daten, die im Internetbrowser bzw. vom Internetbrowser auf dem Computersystem des Nutzers gespeichert werden."
      [:br]
      "Wir setzen diese ein, um unsere Seite nutzerfreundlicher zu gestalten."]
     [mui/button {:startIcon (r/as-element [check]) :color "secondary" :variant "outlined" :style {:margin "5px 40px 5px 0"}
                  :onClick   #(reset! !cookie-ok true)
                  } "Akzeptieren"]
     ]
    ))


